import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

// Modules Material utilises
import { MatMenuModule } from '@angular/material/menu';

// Autres modules externes utilises 

// Modules communs utilises

// Composants metiers
import { NavigationMenuComponent } from './component/navigation-menu.component';

// Services metier
import { UserModule } from '../../data-domains/humain/user/user.module';

import { EventsModule } from '../../technical-modules/events/event-bus.module';

// Bridges avec la partie angular
import * as angular from 'angular';
import { downgradeComponent } from '@angular/upgrade/static';

@NgModule({
	imports: [
		BrowserModule,
		RouterModule,
		
		MatMenuModule,
		
		UserModule,
		EventsModule
	],
	providers: [
	],
	declarations: [
		NavigationMenuComponent,
	],
	exports: [
	]
})
export class NavigationMenuModule {
	constructor() { }
}

angular.module('auroraApp') //
	.directive('navigationMenu',
		downgradeComponent({ component: NavigationMenuComponent })
	) //
;